import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import PROVIDER_SEARCH_TELEMETRY from './ProviderSearchTelemetry.graphql';

export const useProviderSearchTelemetry = (options) =>
  useCustomQuery(PROVIDER_SEARCH_TELEMETRY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'providerSearchTelemetry',
  });
